import { gql, useQuery } from "@apollo/client";
import React, { PropsWithChildren, useContext } from "react";
import { ContextUser } from "src/context/ContextUser";
import { Graph } from "src/generated/graph";

const QUERY = gql`
  query queryList($supplier: Int) {
    categoryList {
      id
      name {
        en
      }
      parentID
      subCategory
    }

    brandList(status: APPROVED, limit: 10000, owned: true, merchantId: $supplier) {
      id
      alias
      name
      banner
      picture
      description
      status
    }

    supplierVendorList {
      id
      name
      contactInfo
      address
      note
      margin
    }
  }
`;

interface Props {
  category: Graph.Category[];
  brand: Graph.Brand[];
  vendor: Graph.SupplierVendor[];
}

const ClassificationContext = React.createContext<Props>({
  category: [],
  brand: [],
  vendor: [],
});

export function useClassification() {
  return useContext(ClassificationContext);
}

export function ClassificationProvider(props: PropsWithChildren<unknown>) {
  const { merchant } = useContext(ContextUser);
  const { data } = useQuery<Graph.Query>(QUERY, {
    fetchPolicy: "cache-and-network",
    variables: {
      supplier: Number(merchant.id),
    },
  });

  return (
    <ClassificationContext.Provider
      value={{
        category: data?.categoryList || [],
        brand: data?.brandList || [],
        vendor: data?.supplierVendorList || [],
      }}
    >
      {props.children}
    </ClassificationContext.Provider>
  );
}
